var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41 40",
    style: {
      enableBackground: "new 0 0 41 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:none;stroke:#070707;stroke-width:2;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.0654,
    y1: 17.1627,
    x2: 35.0654,
    y2: 10.6627,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC16E",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE73C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.5,32.3c-2.8-0.9-8.1-5-10.3-7.3c-0.9-0.9-0.3-2.2,0.6-3.1c4.5-4.2,8.8,0.8,10.6,2.2 c0.3,0.3,0.8,0.3,1.2,0.3c1.5-0.1,4-0.5,5.4-0.5c0.3,0,0.6,0.1,0.9,0.2c2.9,1.4,4.2,4.7,4.6,6.3c0.3,1.3-2.4,3-4.7,4.2 c-1.1,0.6-2.4,0.5-3.5-0.1L24.4,33C23.8,32.7,23.1,32.5,22.5,32.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.4,6.1C8.6,6,8.6,5.9,8.7,5.9c1.3-1.2,3.2-1.2,4.5,0c0.1,0,0.1,0.1,0.2,0.2l2.4,2.4c1.3,1.3,1.7,3.4,1,5.1 s-0.4,3.8,1,5.1l4,4c1.3,1.3,3.4,1.7,5.1,1c1.7-0.8,3.8-0.4,5.1,1l2.4,2.4c0.1,0.1,0.2,0.2,0.2,0.2c1.2,1.3,1.2,3.2,0,4.5 c0,0.1-0.1,0.1-0.2,0.2l-1.5,1.5c-1.2,1.2-2.9,1.7-4.6,1.3C17,32.3,8.1,23.5,5.6,12.2C5.2,10.5,5.8,8.8,7,7.6L8.4,6.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.21eda7694dcf798000250890607a0bb0.svg";
export { ForwardRef as ReactComponent };